export default __webpack_public_path__ + "ca3d7bcdbb4348d53a1ee6bfb2b7358b.png";